import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const editArticuloCantidadFormSchema = z.object({
    cantidad: z.number({ message: "Este campo es requerido" })
})

export default function EditArticuloCantidadForm({
    form,
    ...props
}: FormProps<z.infer<typeof editArticuloCantidadFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.NumberField name="cantidad" label="Cantidad" decimalScale={0} allowNegative />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}